'use strict';

/**
 * Survey (Antavo profiling flow) in-card step machine.
 *
 * The card CTA requests the flow's next question; every submitted answer
 * returns either the following question or the completion state. All markup
 * arrives server-rendered, so this module only swaps fragments and posts the
 * answer. The answer is derived from the rendered inputs at submit time, so
 * swapping in the next fragment resets the state naturally. The display-only
 * question count rides from the card through every post so the fragments can
 * show "Question N of M".
 */

var flowAjax = require('./_flowAjax');

/**
 * Reads the flow's current answer from the rendered inputs.
 *
 * @param {jQuery} $flow - The flow container
 * @returns {string|Array|null} - The single value, the multi-choice array,
 *   or null when nothing is answered yet
 */
function currentAnswer($flow) {
    var $selected = $flow.find('.js-survey-option.selected');
    if ($selected.length) {
        var values = $selected.map(function () {
            return $(this).attr('data-value');
        }).get();
        return $flow.attr('data-multi-choice') === 'true' ? values : values[0];
    }
    var $input = $flow.find('.js-survey-value');
    if ($input.length && $input.val()) {
        return $input.val();
    }
    return null;
}

/**
 * @param {jQuery} $flow - The flow container
 */
function syncSubmitState($flow) {
    var answer = currentAnswer($flow);
    $flow.find('.js-survey-submit').prop('disabled', answer === null);
}

/**
 * A freshly swapped-in question may already carry an answerable value (the
 * slider renders pre-filled with its minimum); sync the submit button so
 * the default is submittable without touching the control.
 *
 * @param {jQuery} $card - The card that just received a fragment
 */
function onFragmentSwapped($card) {
    var $flow = $card.find('.js-survey-flow');
    if ($flow.length) {
        syncSubmitState($flow);
    }
}

module.exports = {
    /**
     * Wires the delegated survey-flow events.
     */
    init: function () {
        // Card CTA: open the flow with its first unanswered question.
        $('body').on('click', '.js-survey-start', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var $card = $btn.closest('.js-loyalty-activity-card');
            var data = { flowId: $btn.attr('data-flow-id') };
            if ($btn.attr('data-question-count')) {
                data.questionCount = $btn.attr('data-question-count');
            }
            $btn.prop('disabled', true);
            flowAjax.post({
                url: $btn.attr('data-url'),
                data: flowAjax.withCsrf($card, data),
                $card: $card,
                $restore: $btn,
                onSwapped: function () {
                    onFragmentSwapped($card);
                }
            });
        });

        // Option select: single-select replaces the selection; a
        // multi-choice question toggles each option. aria-pressed mirrors
        // the selected class for assistive tech.
        $('body').on('click', '.js-survey-flow .js-survey-option', function (e) {
            e.preventDefault();
            var $option = $(this);
            var $flow = $option.closest('.js-survey-flow');
            if ($flow.attr('data-multi-choice') === 'true') {
                $option.toggleClass('selected');
                $option.attr('aria-pressed', String($option.hasClass('selected')));
            } else {
                $flow.find('.js-survey-option').removeClass('selected').attr('aria-pressed', 'false');
                $option.addClass('selected').attr('aria-pressed', 'true');
            }
            syncSubmitState($flow);
        });

        // Value inputs: numeric slider, date picker, and free text.
        $('body').on('input change', '.js-survey-flow .js-survey-value', function () {
            var $input = $(this);
            var $flow = $input.closest('.js-survey-flow');
            $flow.find('.js-survey-slider-value').text($input.val());
            syncSubmitState($flow);
        });

        // Submit the current answer; the response is the next question or
        // the completion state.
        $('body').on('click', '.js-survey-flow .js-survey-submit', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var $flow = $btn.closest('.js-survey-flow');
            var $card = $flow.closest('.js-loyalty-activity-card');
            var answer = currentAnswer($flow);
            if (answer === null || (Array.isArray(answer) && !answer.length)) {
                return;
            }

            var data = {
                flowId: $flow.attr('data-flow-id'),
                questionId: $flow.attr('data-question-id'),
                // Decides how the answer is typed on the wire: Antavo 500s
                // on a numeric_slider answer sent as a quoted string.
                questionType: $flow.attr('data-question-type')
            };
            if ($flow.attr('data-question-count')) {
                data.questionCount = $flow.attr('data-question-count');
            }
            if (Array.isArray(answer)) {
                data.answer = JSON.stringify(answer);
                data.multiChoice = 'true';
            } else {
                data.answer = String(answer);
            }

            $btn.prop('disabled', true);
            flowAjax.post({
                url: $flow.attr('data-answer-url'),
                data: flowAjax.withCsrf($card, data),
                $card: $card,
                $restore: $btn,
                // No success toast: the completion fragment that replaces the
                // card already carries Antavo's own message, so a toast said
                // the same thing twice.
                onSwapped: function () {
                    onFragmentSwapped($card);
                }
            });
        });
    }
};
